// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"99":"7e6dfe57","364":"b5612c90","404":"e63c0816","536":"0a941835","835":"66abf6a4"}[chunkId] + ".chunk.css";
};